module.exports = __webpack_public_path__ + "static/media/signup-mobile.cc9484fe.png";